export const MAP_EDITOR_URL_FRAGMENT = 'MapEditor';
